module.exports = __webpack_public_path__ + "static/drag_and_drop_form@3x.ecfc4dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/drag_and_drop_form@3x.png
// module id = 220
// module chunks = 193162123475590 216210090109534